import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import PageLoader from "../../components/ui/pageLoader/PageLoader";
import Layout from "../../layouts/Layout";
import ProtectedRoute from "../Routes/ProtectedRoute";
import { hasPermission } from "../../utils/AuthorizeNavigation/authorizeNavigation2";
import { ResetPassword } from "../../pages/ResetPassword/ResetPassword";
import Unauthorize from "../../pages/unauthorize/Unauthorize";
import AuthorizationWrap from "../../app/auth/AuthorizationWrap";
import TwoFactorAuthentication from "../../pages/twoFactorAuthentication/TwoFactorAuthentication";
import ForgotPassword from "../../pages/forgotPassword/ForgotPassword";

const NotFound = React.lazy(() => import("../../pages/errors/NotFound"));
const Login = React.lazy(() => import("../../pages/login/Login"));

const AppRoutes = (props) => {
  return (
    <Router>
      <React.Suspense fallback={<PageLoader />}>
        <Routes>
          <Route
            name="Layout"
            path="/"
            element={
              <ProtectedRoute>
                <Layout componentRoutes={props.componentRoutes} />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/Dashboard" replace />} />
            {props.componentRoutes.map(
              (route) =>
                !hasPermission(route.securityKey)?.noPermission && (
                  <Route
                    key={route.id}
                    path={route.path}
                    name={"test"}
                    element={
                      <AuthorizationWrap authorizationRole={route.allowedRole} key={route.id}>
                        <route.component securityKey={route.securityKey} />
                      </AuthorizationWrap>
                    }
                  />
                )
            )}
          </Route>

          <Route exact name="Login" path="/login" element={<Login />} />
          <Route path="/ResetPassword/:id" element={<ResetPassword />} />
          <Route path="/Unauthorize" element={<Unauthorize />} />
          <Route exact name="ForgotPassword" path="/ForgotPassword" element={<ForgotPassword />} />
          <Route exact name="TwoFactorAuthentication" path="/TwoFactorAuthentication" element={<TwoFactorAuthentication />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </React.Suspense>
    </Router>
  );
};
export default AppRoutes;
